// features/configuration.dependencies.js

import apiSendgridConfiguration from "../api";

export const loadConfigurationDependencies = async () => {
  const [credentialsRes] = await Promise.allSettled([
    apiSendgridConfiguration.getCredentials(),
  ]);

  const extract = (res) =>
    res.status === "fulfilled" ? res.value?.data?.data || [] : [];

  return {
    credentials: extract(credentialsRes),
  };
};
